import React, { Fragment, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import { useUserData } from "components/customHooks/userDataContext";
import Navbar from "pages/Navbar";
import Header from "pages/Header";

import TimeSheet from "../pages/provider/TimeSheet";
import UpdateUserTimeSheet from "../pages/provider/UpdateUserTimeSheet";
import UpdateTeamTimeSheet from "../pages/provider/UpdateTeamTimeSheet";
import TimeSheetLandingPage from "../pages/provider/TimeSheetLandingPage";

import Auth from "pages/login";
import MainDashboard from "pages/MainDashboard";
import PatientLogin from "pages/patient/PatientLogin";
import { PatientDataProvider } from "components/customHooks/usePatientContext";
import PracticeRedirectPage from "components/PracticeRedirectPage";
import PatientHeader from "pages/patient/Patientheader";

import scribeRoutes from "routes/scribe";
import providerRoutes from "routes/provider";
import kioskRoutes from "routes/kiosk";
import adminRoutes from "routes/admin";
import patientBalance from "routes/patientBalance";
import callerRoute from "routes/caller";
import AdminDashboard from "pages/superadmin/AdminDashboard";
import clinicalRoutes from "./clinical";

const GetRoutes = ({ type }) => {
  switch (type) {
    case "provider":
      return (
        <Routes>
          {providerRoutes.map((item, index) => (
            <Route
              path={item.path}
              Component={item.component}
              key={index}
              isExact={item.isExact}
            />
          ))}
        </Routes>
      );
    case "admin":
      return (
        <Routes>
          {adminRoutes.map((item, index) => (
            <Route
              path={item.path}
              Component={item.component}
              key={index}
              isExact={item.isExact}
            />
          ))}
        </Routes>
      );
    case "patient":
      return (
        <Routes>
          {patientBalance.map((item, index) => (
            <Route
              path={item.path}
              Component={item.component}
              key={index}
              isExact={item.isExact}
            />
          ))}
        </Routes>
      );
    case "scribe":
      return (
        <Routes>
          {scribeRoutes.map((item, index) => (
            <Route
              path={item.path}
              Component={item.component}
              key={index}
              isExact={item.isExact}
            />
          ))}
        </Routes>
      );
    case "caller":
      return (
        <Routes>
          {callerRoute.map((item, index) => (
            <Route
              path={item.path}
              Component={item.component}
              key={index}
              isExact={item.isExact}
            />
          ))}
        </Routes>
      );
    case "clinical":
      return (
        <Routes>
          {clinicalRoutes.map((item, index) => (
            <Route
              path={item.path}
              Component={item.component}
              key={index}
              isExact={item.isExact}
            />
          ))}
        </Routes>
      );
    default:
      return null;
  }
};

const PrivateRoute = () => {
  const [collapsed, setCollapsed] = useState(true);
  const userData = useUserData();
  const { pathname } = useLocation();

  const isLoggedIn = () => {
    if (userData) {
      return new Date() - new Date(userData.loginTime) < 3600000;
    }
    return false;
  };

  if (pathname.includes("kiosk")) {
    return (
      <Fragment>
        {userData?.userType === "patient" ? (
          <PatientDataProvider>
            <PatientHeader />

            {kioskRoutes.map((item, index) => (
              <Route
                path={item.path}
                element={item.component}
                key={index}
                isExact={item.isExact}
              />
            ))}
          </PatientDataProvider>
        ) : (
          <Navigate to="/kiosk/practice-login" replace />
        )}
      </Fragment>
    );
  }
  if (!isLoggedIn()) return <Navigate to="/login" replace />;

  return (
    <Fragment>
      <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Header collapsed={collapsed} setCollapsed={setCollapsed} />
      <main className="main-container">
        {GetRoutes({ type: userData?.userType })}
      </main>
    </Fragment>
  );
};

function AppRoutes() {
  const userData = useUserData();

  return (
    <Routes>
      <Route path="/login" element={<Auth />} />
      <Route path="/kiosk/practice-login" element={<PatientLogin />} />
      {userData &&
        !userData?.selected_practice &&
        userData.userType === "Admin" && (
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        )}
      {userData && (
        <Route path="/select-practice" element={<PracticeRedirectPage />} />
      )}
      {userData && !userData?.selected_practice && (
        <Route path="/timesheet" element={<TimeSheetLandingPage />} />
      )}
      {userData && !userData?.selected_practice && (
        <Route path="/timesheet/add" element={<TimeSheet />} />
      )}
      {userData && !userData?.selected_practice && (
        <Route path="/timesheet/update" element={<UpdateUserTimeSheet />} />
      )}
      {userData && !userData?.selected_practice && (
        <Route path="/teamtimesheet" element={<UpdateTeamTimeSheet />} />
      )}
      {userData && userData?.selected_practice && (
        <Route path="/main-dashboard" element={<MainDashboard />} />
      )}

      <Route path="/*" element={<PrivateRoute />} />
    </Routes>
  );
}

export default AppRoutes;
